module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./zh-HANT.coffee"));
	}, "locale/zh-HANT");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/zh-HANT.coffee
// module id = 309
// module chunks = 100